import { Box, Grid, Typography } from '@mui/material';
import React from 'react';

export const SectionCard = ({ children, sx, ...props }) => (
  <Box
    sx={{
      bgcolor: 'grey.50',
      border: '1px solid',
      borderColor: 'grey.200',
      borderRadius: 2,
      p: 2.5,
      mb: 3,
      ...sx,
    }}
    {...props}
  >
    {children}
  </Box>
);

export const SectionHeader = ({ children, sx, ...props }) => (
  <Typography
    variant="subtitle1"
    sx={{
      fontWeight: 600,
      color: 'text.primary',
      borderLeft: '3px solid',
      borderColor: 'primary.main',
      pl: 1.5,
      mb: 2,
      ...sx,
    }}
    {...props}
  >
    {children}
  </Typography>
);

export const FieldRow = ({ children, spacing = 2.5, ...props }) => (
  <Grid container spacing={spacing} {...props}>
    {children}
  </Grid>
);
